const emailRegExp = (): RegExp => /^\w+[+.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i;

export default emailRegExp;
